/**
 * Contenu de chaque version du COPSOQ III (catalogue : `@repo/utils`,
 * `copsoq3Versions.ts`). La partie 2 a la même structure partout — questions
 * Q01–Q54, échelles, domaines — et seules ses formulations changent : le
 * score et la restitution n'ont pas à connaître la version. Les parties 1 et
 * 3 ne sont proposées que par certaines versions.
 */

import { VersionCopsoq3Enum } from "@convex/schema";
import type { EcranQuestions } from "./copsoq3-ecrans";
import { copsoq3Questions as questionsUniverselle } from "./copsoq3-data";
import {
  copsoq3Questions as questionsPompiers,
  type Copsoq3Question,
} from "./copsoq3-pompiers-data";
import { copsoq3EcransPartie1 } from "./copsoq3-partie1-data";
import { copsoq3EcransPartie3 } from "./copsoq3-partie3-data";

export interface QuestionnaireCopsoq3 {
  /** Partie 2, scorée. */
  questions: readonly Copsoq3Question[];
  /** Partie 1 (profil) ; vide si la version ne la propose pas. */
  partie1: readonly EcranQuestions[];
  /** Partie 3 (questions médicales) ; vide si la version ne la propose pas. */
  partie3: readonly EcranQuestions[];
}

export const QUESTIONNAIRES_COPSOQ3: Record<
  VersionCopsoq3Enum,
  QuestionnaireCopsoq3
> = {
  [VersionCopsoq3Enum.UNIVERSELLE]: {
    questions: questionsUniverselle,
    partie1: [],
    partie3: [],
  },
  [VersionCopsoq3Enum.POMPIERS]: {
    questions: questionsPompiers,
    partie1: copsoq3EcransPartie1,
    partie3: copsoq3EcransPartie3,
  },
};
